import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Output,
} from '@angular/core';

import { MessageType } from '../../interfaces/message-type.enum';
import { SnackBarVisibility } from '../../interfaces/snack-bar-visibility.enum';

import { snackBarAnimation } from './snack-bar.animation';

@Component({
  selector: 'atx-snack-bar',
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [snackBarAnimation],
  standalone: false,
})
export class SnackBarComponent {
  @Output() public triggeredAction = new EventEmitter<void>();

  get actionTextClass() {
    return `text-${this.type}`;
  }

  public message = '';
  public actionName = '';
  public type: MessageType = MessageType.INFO;

  @HostBinding('@state')
  public state = SnackBarVisibility.VISIBLE;

  public triggerAction() {
    this.triggeredAction.next();
  }
}
